import React, { useEffect, useState } from 'react';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import System from 'src/helper/system';
import { Tooltip } from 'src/component/Global/Tooltip';
import { useQuoteStore } from 'src/hooks/quote';

const QuoteMessagePopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props;
    const [{ submittedQuoteList }, {  }, { send_submitted_quote_email }] = useQuoteStore();
    const c = System.getParams();
    const [quoteListData, setQuoteListData] = useState({})
    const [message, setMessage] = useState("")

    useEffect(() => {
        if (submittedQuoteList?.records?.length > 0) {
            setQuoteListData(submittedQuoteList?.records[0])
        }
    }, [submittedQuoteList])

    const onHide = () => {
        SetStatus(false)
    };

    const onSubmit = async () => {

        let res = {
            "manufacturerPartNumber": Helper.valueIsNotNull(data?.single_quote_detail_item?.manufacturerPartNumber)?data?.single_quote_detail_item?.manufacturerPartNumber:"-",
            "manufacturer": Helper.valueIsNotNull(data?.single_quote_detail_item?.manufacturer)?data?.single_quote_detail_item?.manufacturer:"-",
            "quoteNumber": Helper.valueIsNotNull(c?.quote_number)?c?.quote_number:"-",
            "buyer": Helper.valueIsNotNull(quoteListData?.buyer)?quoteListData?.buyer:"-",
            "message": Helper.valueIsNotNull(message)?message:"-"
        }

        let result = await send_submitted_quote_email(res);
        if (result) {
            System.popup('ConfirmationPopup')
        }   
    };

    return (
        <>
            <div className="avnet-modal modal-650">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×</button>
                    <div className="modal-header">

                        <h4 className="modal-title text-center"><b>Quote Messages</b></h4>
                    </div>
                    <div className="modal-body">
                        <div className="row bs5">
                            <div className="col-6">
                                <h5 className='mb-3 font-arial'><b>QUOTE INFORMATION</b></h5>
                                <div>
                                    <div>
                                        {/* {qtStatus === 'PND' ?
                                            <><b>Web Quote Number:</b> {quoteProvisionalNumber} </> :
                                            <><b>Quote Number:</b> {quoteListData?.quote_number}</>} */}
                                        <b>Quote Number:</b> {c?.quote_number}
                                    </div>
                                    <div><b>Buyer:</b> {Helper.valueIsNotNull(quoteListData?.buyer)?quoteListData?.buyer:(System.avUserInfoData.userName)}</div>
                                    <div><b>Status:</b> {data?.single_quote_detail_item?.status}</div>
                                    <div><b>Date Submitted:</b> {quoteListData?.quoteRequestedDate && Helper.dateFormatFromString(quoteListData?.quoteRequestedDate)} </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <h5 className='mb-3 font-arial'><b>PART INFORMATION</b></h5>
                                <div>
                                    <div>
                                        <div><b>Manufacturer:</b> {data?.single_quote_detail_item?.manufacturer}</div>
                                        <div><b>Manufacturer Part Number:</b> {data?.single_quote_detail_item?.manufacturerPartNumber}     </div>
                                        <div><b>Customer Part Number:</b> {data?.single_quote_detail_item?.customerPartNumber}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="alert bg-grey2 mt-4 border-0 rounded-0 p-3">
                            <Tooltip position={'bottom'}
                                opener={() => (<span><b>Subject:</b> {`In regard to the Quote Number: ${c?.quote_number} ...`}</span>)}
                                content={() => (
                                    <div>
                                        {`${data?.single_quote_detail_item?.manufacturerPartNumber} for ${data?.single_quote_detail_item?.soldToCustomerName} - ${data?.single_quote_detail_item?.soldToCustomerAccountNo}`}
                                    </div>
                                )}
                            />
                        </div>
                        <div className="form-group">
                            <textarea className="w-100" rows="5" id="message" placeholder="Type your message.."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                maxLength="255"
                            />
                            <span className="d-block text-right mt-2 text-black-stone"><i> Characters remaining: {255 - message.trim().length > 0 ? 255 - message.trim().length : 0}/255 </i></span>
                        </div>

                    </div>
                    <div className="modal-footer text-center">
                        <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>Cancel</button>
                        <button className="bs5 btn btn-primary w145"
                            onClick={() => {
                                onSubmit()
                            }}>send</button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default QuoteMessagePopup;